import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-cuadrosSalida',
  templateUrl: './cuadrosSalida.component.html',
  styleUrls: ['./cuadrosSalida.component.css']
})
export class CuadrosSalidaComponent implements OnInit {

  constructor(
    private router:Router
  ) { }

  ngOnInit() {
  }

  irCuadrosChv(){
    this.router.navigate(['CuadrosSalidaChv']);
  }

  irCuadrosFivi(){
    this.router.navigate(['CuadrosSalidaFivi']);
  }



}
